<template>
  <div>
    <div class="row">
      <div class="col-xl-9">
        <h5 class="v-label theme--light mb-7">Droit utilisateur</h5>
      </div>
      <div v-if="selectedUserRights.length === 0" class="col-xl-3 text-end">
        <a class="btn btn-primary" @click.stop="dialog = true">
          Choisir un droit utilisateur
        </a>
      </div>
      <div v-else class="col-xl-3 text-end">
        <a class="btn btn-primary" @click.stop="dialog = true">
          Choisir un autre droit utilisateur
        </a>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-12">
        <div class="form-group">
          <v-simple-table class="elevation-1" v-if="selectedUserRights.length > 0">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Nom du droit utilisateur associé à l'utilisateur</th>
                </tr>
              </thead>
                <tr>
                  <td>
                    <div class="d-flex justify-content-between align-items-center">
                      <div v-for="userRight in selectedUserRights.filter(ur => typeof ur === 'object' && ur !== null)" :key="userRight.id" class="d-flex align-center pl-4">
                        {{ userRight.name }}
                        <div>
                          <v-btn color="transparent" text @click="removeUserRight()">
                            <div class="fa fa-trash" style="color: #e6007e"></div>
                          </v-btn>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
            </template>
          </v-simple-table>
          <v-simple-table v-else>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Aucun droit utilisateur n'est associé à l'utilisateur</th>
                </tr>
              </thead>
            </template>
          </v-simple-table>
        </div>
      </div>
    </div>

    <UserRightModal
      @onClose="onClose"
      :userRights="userRights"
      :dialog="this.dialog"
      @selectUserRight="addUserRight"
    ></UserRightModal>

  </div>
</template>

<script>
import UserRightModal from "@/components/admin/userRight/modal/userRightModal";

export default {
  components:{
    UserRightModal,
  },
  props: {
    userRights : Array,
    selectedUserRights : Array,
  },
  data: () => ({
    dialog: false,
  }),
  methods: {
    addUserRight(userRight) {
      this.$emit("addUserRight", userRight);
      this.dialog = false;
    },
    removeUserRight() {
      if (confirm("Are you sure you want to delete this item?")) {
        this.$emit("removeUserRight");
      }
    },
    onClose(){
      this.dialog = false
    },
  },
};
</script>
